import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const MyDataLink = () => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_data";
  const theme = useTheme();

  return (
    <Grid
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      <Typography
        style={{
          color: theme.palette.primary.main,
          fontWeight: "bold",
        }}
      >
        {`${t(`${tRP}.view_change`)}`}
      </Typography>
    </Grid>
  );
};
export default MyDataLink;
